import React from "react";
import styles from "./styles.css";
import checkIcon from "./images/check.svg";
import PropTypes from "prop-types";
import ppsrLogo from "./images/ppsr.png";
import Button from "../../shared/button";
import getCarInfo from "../../../utils/helpers/get-car-info";

const ClassifiedCdpPpsrReportBanner = ({ points = [
    // todo:deepak cms
    {
        point: "No stolen vehicle"
    },
    {
        point: "No outstanding loan"
    },
    {
        point: "No write offs on record"
    },
    {
        point: "No major accidental damage"
    }
], content }) => {
    const {ppsrReportLink = ""} = content || {};
    const {isInternalListing} = getCarInfo(content) || {};

    const handleOpenReport = () => {
        window.open(ppsrReportLink, "_blank");
    };
    const getPpsrText = () => {
        return {
            heading: ppsrReportLink ? "Free PPSR® with Cars24" : "Your free PPSR® report is being generated...",
            subHeading: ppsrReportLink ? "Every car comes with a free PPSR report, giving you peace of mind at Cars24" : "Seems like PPSR is facing some downtime. You report will be ready soon"
        };
    };
    const {heading, subHeading} = getPpsrText();
    return (
        <div styleName={`styles.ppsrBannerWrapper ${ppsrReportLink ? "" : "styles.loadingBorder"}`}>
            <div styleName={"styles.ppsrTopSection"}>
                {(isInternalListing && ppsrReportLink) && <div styleName={"styles.contentWrap"}>
                    <p styleName={"styles.heading"}>
                        We’ve got you covered with Cars24 Certified Assurance
                    </p>
                    <div styleName={"styles.pointsWrapper"}>
                        {points.map((i, index) => (
                            <p key={index} styleName={"styles.pointText"}>
                                <img src={checkIcon} alt="check" />
                                {i.point}
                            </p>
                        ))}
                    </div>
                    <p styleName={"styles.subHeading"}>Please check with PPSR report below</p>
                </div>}
                <div styleName={`styles.bannerWrapper ${ppsrReportLink ? "" : "styles.loadingbackground"} ${isInternalListing ? "" : "styles.dealerBannerTop"}`}>
                    <img src={ppsrLogo} />
                    <div styleName={"styles.bannerContentWrap"}>
                        <div styleName={"styles.leftSection"}>
                            <p styleName={`styles.bannerHeading ${ppsrReportLink ? "" : "styles.loadingHeading"}`}>{heading}</p>
                            <p styleName={`styles.bannerSubHeading ${ppsrReportLink ? "" : "styles.loadingSubheading"}`}>{subHeading}</p>
                        </div>
                        {ppsrReportLink && <Button variant={"tertiary"} transparent={true} onClick={handleOpenReport} text={"Download the report"} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

ClassifiedCdpPpsrReportBanner.propTypes = {
    points: PropTypes.array,
    content: PropTypes.object
};
export default ClassifiedCdpPpsrReportBanner;
